var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponseMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.6,
    height: 76.6,
    viewBox: "0 0 76.6 76.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4971",
    width: 76.6,
    height: 76.6,
    fill: "#1fba9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_48_oran_belul",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10898",
    d: "M54.8,7.1H14.064a2.973,2.973,0,0,0-2.97,2.97V36.521a2.976,2.976,0,0,0,2.97,2.972H54.8a2.978,2.978,0,0,0,2.972-2.972V10.07A2.976,2.976,0,0,0,54.8,7.1M14.064,9.5H54.8a.572.572,0,0,1,.577.575v.494l-20.124,12.9a1.571,1.571,0,0,1-1.748.005l-20.018-12.9V10.07a.568.568,0,0,1,.574-.575M54.8,37.1H14.064a.57.57,0,0,1-.574-.577v-.65L29.316,25.748,27.1,24.322,13.489,33.036V13.414L32.218,25.487a3.959,3.959,0,0,0,4.318-.008L55.379,13.406v19.63L41.718,24.292,39.5,25.711l15.881,10.16v.65a.574.574,0,0,1-.577.577",
    transform: "translate(18.829 12.049)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10899",
    d: "M5.985,12.289A1.2,1.2,0,0,0,4.79,11.094H1.2a1.2,1.2,0,1,0,0,2.392H4.79a1.2,1.2,0,0,0,1.195-1.2",
    transform: "translate(0 18.827)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10900",
    d: "M17.912,12.289a1.2,1.2,0,0,0-1.195-1.195H4.748a1.2,1.2,0,1,0,0,2.392h11.97a1.2,1.2,0,0,0,1.195-1.2",
    transform: "translate(6.025 18.827)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10901",
    d: "M5.673,13.756H2.083a1.2,1.2,0,0,0,0,2.4h3.59a1.2,1.2,0,0,0,0-2.4",
    transform: "translate(1.507 23.345)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10902",
    d: "M17.6,13.756H5.635a1.2,1.2,0,0,0,0,2.4H17.6a1.2,1.2,0,0,0,0-2.4",
    transform: "translate(7.53 23.345)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    d: "M13.313,26.8a2.392,2.392,0,1,0,2.392-2.4,2.394,2.394,0,0,0-2.392,2.4",
    transform: "translate(22.595 41.42)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10904",
    d: "M52.756,43.505a3.592,3.592,0,0,1-3.59,3.59h-38.3a3.592,3.592,0,0,1-3.59-3.59V15.975h-2.4v27.53a5.994,5.994,0,0,0,5.985,5.985h38.3a5.992,5.992,0,0,0,5.985-5.985V28.021h-2.4Z",
    transform: "translate(8.284 27.111)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    d: "M49.166,0h-38.3A5.994,5.994,0,0,0,4.881,5.985V26.333h2.4V5.985a3.589,3.589,0,0,1,3.59-3.59h38.3a3.589,3.589,0,0,1,3.59,3.59V15.56h2.4V5.985A5.992,5.992,0,0,0,49.166,0",
    transform: "translate(8.284 -0.001)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10906",
    d: "M45.4,11.794V2.219H7.1V22.566H9.492V4.614H43v7.18Z",
    transform: "translate(12.05 3.764)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    d: "M7.1,35.127H45.4V28.02H43.007v4.712H9.495V15.974H7.1Z",
    transform: "translate(12.049 27.11)",
    fill: "#1fba9c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseMessage);
export default __webpack_public_path__ + "static/media/ResponseMessage.64ba303ecdc8f221b0515fd4fbf6ca64.svg";
export { ForwardRef as ReactComponent };